import request, { formatServerErrors } from "../config";
import { setAlert } from "./ui";

const LOAD = "LOAD";
const LOAD_SUCCESS = "LOAD_SUCCESS";
const LOAD_FAIL = "LOAD_FAIL";
const UNSET_SESSION = "UNSET_SESSION";
const SET_SESSION = "SET_SESSION";
const REGISTER_USER = "REGISTER_USER";
const REGISTER_USER_SUCCESS = "REGISTER_USER_SUCCESS";
const REGISTER_USER_FAIL = "REGISTER_USER_FAIL";
const REQUEST_LOGOUT = "REQUEST_LOGOUT";
const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
const LOGOUT_FAIL = "LOGOUT_FAIL";
const REFRESH_LOGGED_USER_DATA = "REFRESH_LOGGED_USER_DATA";

const initialState = {
  loading: false,
  logged: true,
  loaded: false,
  user: undefined,
  registration: {
    verification: { loading: true },
    valid: false
  }
};

export default function(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD:
      return {
        ...state,
        loading: true
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        session: true,
        user: action.data.resources[0]
      };
    case LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.data
      };

    case REFRESH_LOGGED_USER_DATA:
      return {
        ...state,
        loading: false,
        session: true,
        user: action.data.resources[0]
      };
    case SET_SESSION:
      return {
        ...state,
        loading: false,
        valid: true,
        user: action.data
      };

    case UNSET_SESSION:
      return {
        ...state,
        loading: false,
        valid: false,
        user: undefined
      };
    case REGISTER_USER:
      return {
        ...state,
        registration: {
          ...state.registration,
          loading: true,
          errors: []
        }
      };

    case "GET_LOGGED_USER_SUCCESS":
      return {
        ...state,
        loading: false,
        session: true,
        user: action.data.resources[0]
      };

    case "VERIFY_TOKEN":
      return {
        ...state,
        registration: {
          loading: true,
          errors: [],
          verification: {
            loading: true
          }
        }
      };
    case "VERIFY_TOKEN_SUCCESS":
      return {
        ...state,
        registration: {
          ...state.registration,
          verification: {
            loading: false,
            tokenIvalid: false
          }
        }
      };

    case "VERIFY_TOKEN_FAIL":
      return {
        ...state,
        registration: {
          ...state.registration,
          verification: {
            loading: false,
            tokenIvalid: true
          }
        }
      };

    case "LOGIN":
      return {
        ...state,
        verifingCredential: true
      };
    case "LOGIN_SUCCESS":
      return {
        ...state,
        valid: true,
        verifingCredential: false,
        wrongCredentials: false,
        user: action.data.resources[0]
      };
    case "LOGIN_FAIL":
      // the user has OTP verification enabled
      if (action.errors.status === 307) {
        return {
          ...state,
          verifingCredential: false,
          otp: true
        };
      }
      // if return 422, it means that the customer
      // has not verified its email address
      if (action.errors.status === 422) {
        return {
          ...state,
          waitingConfirmation: true,
          wrongCredentials: false,
          verifingCredential: false
        };
      }

      return {
        ...state,
        verifingCredential: false,
        wrongCredentials: true,
        otp: false
      };
    case LOGOUT_SUCCESS:
      return {
        ...state,
        valid: false,
        user: null
      };
    case "SHOW_FORGOTTEN_PASSWORD_FORM":
      return {
        ...state,
        forgottenPassword: true
      };
    case "HIDE_FORGOTTEN_PASSWORD_FORM":
      return {
        ...state,
        forgottenPassword: false
      };

    case REGISTER_USER_FAIL:
      return {
        ...state,
        registration: {
          ...state.registration,
          valid: false,
          loading: false,
          errors: formatServerErrors(action.errors.errors)
        }
      };

    case REGISTER_USER_SUCCESS:
      return {
        ...state,
        registration: {
          loading: false,
          errors: [],
          valid: true
        }
      };

    case "SET_PASSWORD_SUCCESS":
      return {
        ...state,
        registration: {
          ...state.registration,
          passwordSetted: true
        }
      };

    case "SET_PASSWORD_FAIL":
      return {
        ...state,
        registration: {
          ...state.registration,
          loading: false,
          errors: formatServerErrors(action.errors.errors),
          valid: false
        }
      };

    default:
      return state;
  }
}

function requestSessionStatus() {
  return { type: LOAD };
}

function receiveSessionStatus(data) {
  return { type: LOAD_SUCCESS, data };
}

function requestLogout() {
  return { type: REQUEST_LOGOUT };
}

function logoutSuccess() {
  return { type: LOGOUT_SUCCESS };
}

function logoutFail() {
  return { type: LOGOUT_FAIL };
}

export function unsetSession() {
  return { type: UNSET_SESSION };
}

export function setSession(user) {
  return { type: SET_SESSION, data: user };
}

export function logout() {
  return dispatch => {
    dispatch(requestLogout());

    return request
      .put("/users/logout")
      .then(resp => {
        dispatch(logoutSuccess());
      })
      .catch(err => {
        dispatch(logoutFail());
      });
  };
}

export function verify(showLoader = true) {
  return dispatch => {
    if (showLoader) {
      dispatch(requestSessionStatus());
    }

    return request
      .get("/users/session")
      .then(resp => {
        dispatch(receiveSessionStatus(resp.data));
      })
      .catch(err => {
        console.log("error /user/session:", err);
        // } else if (err.response.status === 401) {
        //   dispatch(unsetSession());
        // }
      });
  };
}

function requestToServer(
  method,
  url,
  actionType,
  formValues = {},
  alert = false,
  queryParams,
  dispatch
) {
  const config = {
    method,
    url,
    data: formValues,
    params: queryParams
  };

  const loadingFunc = () => ({ type: actionType });
  const successFunc = data => ({ type: `${actionType}_SUCCESS`, data });
  const errorFunc = errors => ({ type: `${actionType}_FAIL`, errors });

  dispatch(loadingFunc());

  request(config)
    .then(resp => {
      dispatch(successFunc(resp.data));
      // if user request alert, dispatch a new action
      if (alert) {
        dispatch(setAlert(alert));
      }
    })
    .catch(resp => {
      // if user request alert, dispatch a new action
      if (alert) {
        dispatch(setAlert(resp.response.data.message));
      }

      if (typeof resp.response.data === "string") {
        dispatch(errorFunc({ error: resp.response.data, status: resp.response.status }));
      } else {
        dispatch(errorFunc({ ...resp.response.data, status: resp.response.status }));
      }
    });
}

export function getFromServer(url, actionType, alert, queryParams) {
  return dispatch => {
    requestToServer("get", url, actionType, {}, alert, queryParams, dispatch);
  };
}
